import { Auth } from 'aws-amplify';

import config from '~/config';

Auth.configure({
  mandatorySignIn: false,
  region: 'ap-southeast-2',
  userPoolId: config.COGNITO_USER_POOL_ID,
  userPoolWebClientId: config.COGNITO_USER_POOL_CLIENT_ID,
});
